module.exports = __webpack_public_path__ + "img/container&-van-truck-1.79370766.png";